module.exports = __webpack_public_path__ + "img/Q&A.b2222b67.png";